import { render, staticRenderFns } from "./CoEditableText.vue?vue&type=template&id=7b622d18&scoped=true&"
import script from "./CoEditableText.vue?vue&type=script&lang=ts&"
export * from "./CoEditableText.vue?vue&type=script&lang=ts&"
import style0 from "./CoEditableText.vue?vue&type=style&index=0&id=7b622d18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b622d18",
  null
  
)

export default component.exports